'use client';

import React from 'react';

interface ClientsFilterPillsProps {
  selectedFilter: 'ALL' | 'ACTIVE' | 'INACTIVE' | 'NEVER';
  onSelectFilter: (filter: 'ALL' | 'ACTIVE' | 'INACTIVE' | 'NEVER') => void;
  counts: {
    all: number;
    active: number;
    inactive: number;
    never: number;
  };
}

export default function ClientsFilterPills({
  selectedFilter,
  onSelectFilter,
  counts
}: ClientsFilterPillsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 pt-1 pb-1">
      <button
        onClick={() => onSelectFilter('ALL')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition ${
          selectedFilter === 'ALL'
            ? 'bg-[#10b981] text-white shadow-sm'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Todas {counts.all}
      </button>

      <button
        onClick={() => onSelectFilter('ACTIVE')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition ${
          selectedFilter === 'ACTIVE'
            ? 'bg-[#10b981] text-white shadow-sm'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Activas {counts.active}
      </button>

      <button
        onClick={() => onSelectFilter('INACTIVE')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition ${
          selectedFilter === 'INACTIVE'
            ? 'bg-[#10b981] text-white shadow-sm'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Inactivas 90+ días {counts.inactive}
      </button>

      <button
        onClick={() => onSelectFilter('NEVER')}
        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition ${
          selectedFilter === 'NEVER'
            ? 'bg-[#10b981] text-white shadow-sm'
            : 'bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300'
        }`}
      >
        Nunca vinieron {counts.never}
      </button>
    </div>
  );
}
